// 商品订单详情
export default {
    heard_title: "商品订单详情",
    heard_btn: "返回",

    // 商品信息
    th_goodsInfo: "商品信息",
    tl_goodsImg: "商品图片",
    tl_goodsName: "商品名称",
    tl_goodsPrice: "价格",
    tl_serial: "货号",
    tl_specName: "规格",
    tl_quantity: "数量",
    tl_amount: "小计",
    tl_total: "合计:",

    // 备注弹出框
    dt_memoOrder: "备注订单",
    dt_closeOrder: "关闭订单",
    dp_memo: "请输入备注内容",

    // 提示
    sm_closeOrder: "关闭订单成功",
    sm_memoOrder: "备注订单成功"
};
